export default [
    {
        term: 'menu_item_1.title',
        href: '#about',
    },
    {
        term: 'menu_item_2.title',
        href: '#details',
    },
    {
        term: 'menu_item_3.title',
        href: '#benefits',
    },
    {
        term: 'menu_item_4.title',
        href: '#contact',
    }
]